




























































import IconBox from '@/components/IconBox'

export default {
    name: 'IconBoxes'

    components:
        IconBox: IconBox

    data: -> fields: @defaultFields

    computed:
        isDark: -> @$parent.isDark
        isSlider: -> @fields.slide_function is 'eingeschaltet'
        smallBoxes: -> @fields.box_size is 'klein'
        gridClass: ->
            'uk-grid uk-child-width-1-2@s uk-child-width-1-3@m': !@smallBoxes
            'uk-grid-small uk-child-width-1-2@s uk-child-width-1-3@m uk-child-width-1-4@l': @smallBoxes

    methods:
        defaultFields: ->
            slide_function: 'ausgeschaltet'
            box_size: 'groß'
            boxes: []

        setContent: (document) ->
            fields =
                slide_function: document.primary.slide_function
                box_size: document.primary.box_size
                boxes: document.items
            $.extend @fields, fields

    created: ->
        @setContent @$attrs.document
}
